var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.applications")) +
                " > " +
                _vm._s(_vm.$t("sidebar.boostsales")) +
                "\n    "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _c("BaseInstallApps", {
            attrs: {
              title: _vm.$t("apps.installapp.message.bootstsaletitle"),
              apps: _vm.apps,
              installed: _vm.getShopInstalledApps,
              pricing: _vm.pricing
            },
            on: { onClickInstallApp: _vm.handleOpenModalInstallApp }
          }),
          _vm._v(" "),
          _c("BaseModalInstallApp", {
            attrs: {
              id: _vm.MODAL_INSTALL_APP,
              selectedApp: _vm.selectedApp,
              installed: _vm.getShopInstalledApps,
              pricing: _vm.pricing,
              isSubmitting: _vm.isSubmitting
            },
            on: {
              onClose: _vm.handleCloseModal,
              onApply: _vm.handleApply,
              onUninstall: _vm.handleUninstall
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43feceaa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43feceaa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/applications/category/BoostSales.vue
// module id = null
// module chunks = 